// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import OffSvg from '@rsuite/icon-font/lib/action/Off';
var Off = createSvgIcon({
  as: OffSvg,
  ariaLabel: 'off',
  category: 'action',
  displayName: 'Off'
});
export default Off;